import * as React from 'react';
import * as I18n from 'i18n-js';
import FormGroupWithInput from '@reverbdotcom/commons/dist/components/form_group_with_input';
import { IUser } from '@reverbdotcom/commons/dist/components/user_context_provider';
import bind from '@reverbdotcom/commons/dist/bind';
import TokenizedCreditCardHiddenFields, { ICardData } from './tokenized_credit_card_hidden_fields';
import { ITokenizedCreditCardData } from './card_data';
import { useUser } from '@reverbdotcom/commons/dist/user_hooks';
import { isExperimentEnabled } from '@reverbdotcom/commons/dist/user_context_helpers';
import { experiments } from '@reverbdotcom/commons/dist/constants';
import CreditCardNewCardFormFields from '../components/credit_card_new_card_form_fields';

interface Props {
  user: Partial<IUser>;
}

interface State {
  cardData: ICardData;
  tokenizedFields: ITokenizedCreditCardData;
}

export class CreditCardHtmlForm extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      cardData: {
        cardholderName: props.user.name || '',
        cardType: '',
        last4: '',
      },
      tokenizedFields: {
        encryptedSecurityCode: '',
        encryptedExpiryMonth: '',
        encryptedExpiryYear: '',
        encryptedCardNumber: '',
      },
    };
  }

  @bind
  onFieldUpdate(newTokenizedFields: Partial<ITokenizedCreditCardData>) {
    const tokenizedFields: ITokenizedCreditCardData = { ...this.state.tokenizedFields, ...newTokenizedFields };
    this.setState({ tokenizedFields });
  }

  @bind
  onCardDataUpdate(newCardData: Partial<ICardData>) {
    const cardData: ICardData = { ...this.state.cardData, ...newCardData };
    this.setState({ cardData });
  }

  render() {
    return (
      <div>
        <FormGroupWithInput
          inputName="credit_card[cardholder_name]"
          label={I18n.t('discovery.creditCardForm.nameOnCard')}
          value={this.state.cardData.cardholderName}
          updateField={this.onCardDataUpdate}
          fieldName="cardholderName"
          required
        />
        <TokenizedCreditCardHiddenFields
          onTokenizedFieldUpdate={this.onFieldUpdate}
          onCardDataUpdate={this.onCardDataUpdate}
          tokenizedFields={this.state.tokenizedFields}
          cardData={this.state.cardData}
        />
      </div>
    );
  }
}

export default function RolloutCreditCardFormFields() {
  const user = useUser();

  if (isExperimentEnabled(user, experiments.ADYEN_WEB_COMPONENTS_UPDATE)) {
    return <CreditCardNewCardFormFields />;
  }

  return <CreditCardHtmlForm user={user} />;
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/credit_card_html_form.tsx